routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.payResponse', {
      url: "zona-de-pagos/response/{idPay}",
      template: `<pay-response sh-ctrl="shCtrl"></pay-response>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/pay-zone/response/response.config.js